// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { GaContextAsp } from "../schema";

export function serialize_GaContextAsp_internal(value: GaContextAsp): unknown {
  return ((value: { corporateId: number; username: string }): unknown => {
    return {
      corporateId: ((value: number): unknown => {
        return value;
      })(value["corporateId"]),
      username: ((value: string): unknown => {
        return value;
      })(value["username"]),
    };
  })(value);
}
export function serialize_GaContextAsp(obj: GaContextAsp): string {
  return renderJsonWithNumbersAsBigint(serialize_GaContextAsp_internal(obj));
}
export function deserialize_GaContextAsp_internal(value: unknown): ParserResult<GaContextAsp> {
  return ((
    value: unknown,
  ): ParserResult<{
    corporateId: number;
    username: string;
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/GaContextAsp]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/GaContextAsp]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "corporateId")) {
      return { success: false, reason: `[#/components/schemas/GaContextAsp/corporateId]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'corporateId'.` };
    }
    const parsed_corporateId = ((): ParserResult<number> => {
      return ((value: unknown): ParserResult<number> => {
        if (typeof value === "number") {
          return { success: true, value: value };
        }
        return { success: false, reason: `[#/components/schemas/GaContextAsp/corporateId]: '${value}' expected to be of type number.` };
      })(value["corporateId"]);
    })();
    if (!parsed_corporateId.success) {
      return { success: false, reason: parsed_corporateId.reason };
    }
    if (!hasProp(value, "username")) {
      return { success: false, reason: `[#/components/schemas/GaContextAsp/username]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'username'.` };
    }
    const parsed_username = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/GaContextAsp/username]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["username"]);
    })();
    if (!parsed_username.success) {
      return { success: false, reason: parsed_username.reason };
    }
    return { success: true, value: { corporateId: parsed_corporateId.value, username: parsed_username.value } };
  })(value);
}
export function deserialize_GaContextAsp(str: string): ParserResult<GaContextAsp> {
  return deserialize_GaContextAsp_internal(parseJsonWithNumbersAsBigint(str));
}
